import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    gridContainer: {
        width: '100%',
    },
    selectInput: {
        width: '100%',
    },
    textField: {
        width: '100%',
    },
    addButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        paddingTop: '8px',
    },
    button: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
}));

